import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=454988cc&scoped=true&"
import script from "./dashboard.js?vue&type=script&lang=js&"
export * from "./dashboard.js?vue&type=script&lang=js&"
import style0 from "./dashboard.scss?vue&type=style&index=0&id=454988cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454988cc",
  null
  
)

export default component.exports